/**
 * The email auth handoff marker (post-signup landing, Decision 2).
 *
 * A completed email authentication — `loginEmail` resolved, `register`
 * resolved without `requires_verification`, or `verifyEmail` resolved — marks
 * this tab, and the next `fetchUser` (the store's `_fetchUserInner`) reads the
 * mark once at entry and clears it however the fetch ends. Only a load that
 * carries the mark may land on the plan the resolve saved; every other load
 * (a reload, a shared or bookmarked link, Back/Forward, an OAuth return)
 * keeps today's destination.
 *
 * `sessionStorage`, because it is per tab, dies with the tab, and survives the
 * same-tab full-page load the email pages make. The writers are
 * reached only by a resolved auth call; nothing here reads the address bar.
 * Every call swallows a storage throw: no mark means today's behaviour.
 */

const AUTH_HANDOFF_KEY = 'vizday_auth_handoff';

export function markAuthHandoff(): void {
  try {
    sessionStorage.setItem(AUTH_HANDOFF_KEY, '1');
  } catch {
    // Storage refused: no mark, so the load behaves as it did before.
  }
}

export function readAuthHandoff(): boolean {
  try {
    return sessionStorage.getItem(AUTH_HANDOFF_KEY) === '1';
  } catch {
    return false;
  }
}

export function clearAuthHandoff(): void {
  try {
    sessionStorage.removeItem(AUTH_HANDOFF_KEY);
  } catch {
    // Nothing to clear that anything could read.
  }
}
